/**
 * 運搬ルート コードチェック
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/transport_routes/code_validations/exists`

const transport_route_code_validation = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    exists ({ commit }, { code, transport_route_id }) {
      const params = { code: code, transport_route_id: transport_route_id }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default transport_route_code_validation

